import React from 'react'
import Img from './Img'

type Props = {
  title?: string
  subtitle?: string
  icon: string
}

const ValueCard = ({ title = '', subtitle = '', icon }: Props) => {
  return (
    <div className="leading-relaxed">
      <div className="relative bg-white border-gray-700 shadow-md rounded-md pt-full bright:border">
        <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full">
          <Img src={icon} />
        </div>
      </div>
      {title && !subtitle && (
        <p className="m-4 font-medium text-center">{title}</p>
      )}
      {title && subtitle && (
        <>
          <p className="my-4 font-medium">{title}</p>
          <p>{subtitle}</p>
        </>
      )}
    </div>
  )
}

export default ValueCard
